var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRequiredIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85.97a.167.167 0 01.3 0l.79 1.603c.025.05.072.083.126.091l1.77.257c.137.02.191.188.092.285l-1.28 1.248a.167.167 0 00-.048.148l.302 1.762a.167.167 0 01-.242.176l-1.583-.832a.167.167 0 00-.155 0L2.34 6.54a.167.167 0 01-.241-.176L2.4 4.602a.167.167 0 00-.048-.148l-1.28-1.248a.167.167 0 01.092-.284l1.77-.258a.167.167 0 00.125-.09L3.85.97z",
    fill: "url(#paint0_linear_1906_2386)",
    stroke: "url(#paint1_linear_1906_2386)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1906_2386",
    x1: 4,
    y1: 0.877,
    x2: 4,
    y2: 6.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E26969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1906_2386",
    x1: 4,
    y1: 0.877,
    x2: 4,
    y2: 6.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E26969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73331"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRequiredIcon);
export default __webpack_public_path__ + "static/media/star_required_icon.a63877303c897d99ba53f2d1d12968cb.svg";
export { ForwardRef as ReactComponent };